import { WARootState } from '@/store/store';
import { useSelector } from 'react-redux';

type Integration =
  | 'DocuSign'
  | 'MGP'
  | 'Orion'
  | 'RetireUp'
  | 'TD'
  | 'WealthStation'
  | 'WebLink';

export const useIntegration = () => {
  const userInfo = useSelector((s: WARootState) => s.appView.UserInfo);

  const isIntegrationEnabled = (integration: Integration): boolean => {
    const integrations = userInfo?.Integrations;
    return integrations?.[integration] === true;
  };

  return {
    isIntegrationEnabled,
  };
};
